import React, { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Modal, FileInput, Label } from "flowbite-react";

const CreateDoctor = () => {
  const [showForm, setShowForm] = useState(false);
  const [rowPerPage, setRowPerPage] = useState(20);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    specializationId: '',
    qualifications: '',
    experience: '',
    contact_number: '',
    address: '',
    reg_number: '',
    gender: '',
    birthday: '',
    profile_image: '',
  });
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [editId, setEditId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState('');

  const fetchData = async () => {
    try {
      const response = await axios.get('https://backend.amarasinghemedicare.com/doctors/doctorDetails');
      setData(response.data);
    } catch (error) {
      setError(error);
      console.error('Error fetching doctor details:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  function onCloseModal() {
    setOpenModal(false);
    setEmail('');
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      profile_image: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(formData);

    // Validation
    if (!formData.fullName) {
      toast.error("Full Name is required!");
      return;
    }
    if (!formData.email) {
      toast.error("Email is required!");
      return;
    }
    if (!formData.password) {
      toast.error("Password is required!");
      return;
    }
    if (!formData.specializationId) {
      toast.error("Specialization is required!");
      return;
    }
    if (!formData.qualifications) {
      toast.error("Qualifications are required!");
      return;
    }
    if (!formData.experience) {
      toast.error("Experience is required!");
      return;
    }
    if (!formData.contact_number) {
      toast.error("Contact Number is required!");
      return;
    }
    if (!formData.address) {
      toast.error("Address is required!");
      return;
    }
    if (!formData.reg_number) {
      toast.error("Registration Number is required!");
      return;
    }
    if (!formData.gender) {
      toast.error("Gender is required!");
      return;
    }
    if (!formData.birthday) {
      toast.error("Birthday is required!");
      return;
    }
    if (!formData.profile_image) {
      toast.error("Profile Image is required!");
      return;
    }

    const formDataToSubmit = new FormData();
    for (let key in formData) {
      if (key === 'profile_image' && formData[key]) {
        formDataToSubmit.append('profile_image', formData[key]);
      } else {
        formDataToSubmit.append(key, formData[key]);
      }
    }


    try {
      const url = editId
        ? `https://backend.amarasinghemedicare.com/doctors/update/${editId}`
        : 'https://backend.amarasinghemedicare.com/doctors/register';
      const method = editId ? 'put' : 'post';

      console.log(`PUT URL: ${url}`); // 

      const response = await axios({
        method,
        url,
        data: formDataToSubmit,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log(response);

      toast.success(editId ? "Doctor updated successfully!" : "Doctor registered successfully!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setFormData({
        fullName: '',
        email: '',
        password: '',
        specializationId: '',
        qualifications: '',
        experience: '',
        contact_number: '',
        address: '',
        reg_number: '',
        gender: '',
        birthday: '',
        profile_image: '',
      });
      setEditId(null);
      fetchData();
    } catch (error) {
      toast.error(editId ? "Update failed. Please try again." : "Registration failed. Please try again.");
      console.error('Error during registration:', error);
    }
  };

  const handleEdit = (row) => {
    setFormData({
      fullName: row.fullName,
      email: row.email,
      password: '',
      specializationId: row.specializationId,
      qualifications: row.qualifications,
      experience: row.experience,
      contact_number: row.contact_number,
      address: row.address,
      reg_number: row.reg_number,
      gender: row.gender,
      birthday: row.birthday,
      profile_image: row.profileImage,
    });
    setEditId(row.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://backend.amarasinghemedicare.com/doctors/${id}`);
      toast.success("Doctor deleted successfully!");
      fetchData();
    } catch (error) {
      toast.error("Failed to delete doctor. Please try again.");
    }
  };

  useEffect(() => {
    axios.get('https://backend.amarasinghemedicare.com/category/categories')
      .then((response) => setCategories(response.data))
      .catch((error) => console.error('Error fetching categories:', error));
  }, []);

  const columns = [
    { name: 'Full Name', selector: row => row.fullName, sortable: true },
    { name: 'Email', selector: row => row.email, sortable: true },
    { name: 'Specialization', selector: row => row.specialization, sortable: true },
    { name: 'Contact', selector: row => row.contact_number, sortable: true },
    { name: 'Address', selector: row => row.address, sortable: true },
    { name: 'Register No', selector: row => row.reg_number, sortable: true },
    { name: 'Birthday', selector: row => row.birthday, sortable: true },
    {
      name: 'Action',
      cell: row => (
        <div className="flex items-center justify-center space-x-3">
          <button onClick={() => handleEdit(row)} className="flex items-center justify-center font-semibold p-[6px] rounded-md shadow-md bg-green text-white hover:bg-green-500">
            <FaEdit />
          </button>
          <button onClick={() => handleDelete(row.id)} className="flex items-center justify-center font-semibold p-[6px] rounded-md shadow-md bg-red text-white hover:bg-red-500">
            <MdDelete />
          </button>
        </div>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#202643',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '13px',
      },
    },
  };

  const handleChancel = () => {
    setFormData({
      eng_name: '',
      sin_name: '',
      image: null
    });

    setOpenModal(false);
    setEmail('');
  };

  return (
    <div>
      <Toaster />
      <div className="flex">
        <button
          className="text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105"
          onClick={() => setOpenModal(true)}
        >
          Register Doctor
        </button>

      </div>

      <h1 className='mt-5 text-[16px] uppercase font-semibold text-left'>Available Doctors</h1>
      <div className='h-fit p-[1px] mt-2 bg-[#202643]'>
        <DataTable
          columns={columns}
          data={data}
          fixedHeader
          fixedHeaderScrollHeight="80vh"
          className="data-table"
          customStyles={customStyles}
          pagination
          paginationPerPage={rowPerPage}
          paginationRowsPerPageOptions={[10, 20, 50, 100, 200]}
          onChangeRowsPerPage={(newRowsPerPage) => { setRowPerPage(newRowsPerPage) }}
        />
      </div>

      <Modal show={openModal} size="md" onClose={onCloseModal} popup>
        <Modal.Header className='bg-white' />
        <Modal.Body className='bg-white'>
          <div className="space-y-6">
            <h3 className="text-xl font-medium text-gray-900">Register <span className='text-red'>New</span> Doctor</h3>
            <form
              onSubmit={handleSubmit}
              className=""
            >
              <div className="">
                <div>
                  <label htmlFor="fullName" className="table-row text-[#261C53] text-[15px]">Full Name :</label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                <div className="mt-4">
                  <label htmlFor="email" className="table-row text-[#261C53] text-[15px]">Email :</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>

              <div className="mt-4">
                <div>
                  <label htmlFor="password" className="table-row text-[#261C53] text-[15px]">Password :</label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                <div className="mt-4">
                  <label htmlFor="specializationId" className="table-row text-[#261C53] text-[15px]">SpecializationId :</label>

                  <select name="specializationId" id="specializationId" value={formData.specializationId} onChange={handleChange}
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  >
                    <option value="" disabled selected className="text-gray-700">
                      Select your specialization
                    </option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.id} className="text-black bg-white">
                        {category.id}. {category.eng_name} - {category.sin_name}
                      </option>
                    ))}
                  </select>

                </div>
              </div>

              <div className="mt-4 ">
                <div>
                  <label htmlFor="qualifications" className="table-row text-[#261C53] text-[15px]">Qualifications :</label>
                  <input
                    type="text"
                    id="qualifications"
                    name="qualifications"
                    value={formData.qualifications}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

              </div>

              <div className="mt-4">
                <div>
                  <label htmlFor="experience" className="table-row text-[#261C53] text-[15px]">Experience :</label>
                  <input
                    type="text"
                    id="experience"
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>

              <div>
                <div className="mt-4">
                  <label htmlFor="contact_number" className="table-row text-[#261C53] text-[15px]">Contact Number :</label>
                  <input
                    type="text"
                    id="contact_number"
                    name="contact_number"
                    value={formData.contact_number}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>

              <div className="">
                <div className="mt-4">
                  <label htmlFor="address" className="table-row text-[#261C53] text-[15px]">Address :</label>
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                <div className="mt-4 ">
                  <label htmlFor="reg_number" className="table-row text-[#261C53] text-[15px]">Reg Number :</label>
                  <input
                    type="text"
                    id="reg_number"
                    name="reg_number"
                    value={formData.reg_number}
                    onChange={handleChange}
                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                <div className="flex flex-col gap-4 mt-4 sm:flex-row sm:gap-6">
                  {/* Gender Field */}
                  <div className="flex-1">
                    <label htmlFor="gender" className="table-row text-[#261C53] text-[15px]">
                      Gender:
                    </label>
                    <select
                      id="gender"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    >
                      <option value="" disabled>
                        Select Gender
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  {/* Birthday Field */}
                  <div className="flex-1">
                    <label htmlFor="birthday" className="table-row text-[#261C53] text-[15px]">
                      Birthday:
                    </label>
                    <input
                      type="date"
                      id="birthday"
                      name="birthday"
                      value={formData.birthday}
                      onChange={handleChange}
                      className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  </div>
                </div>


                {/* Profile image */}
                <div className="flex mt-6 space-x-4">
                  <div className="w-full">
                    <label htmlFor="profile_image" className="table-row text-[#261C53] text-[15px]">Profile Image:</label>
                    <input
                      type="file"
                      id="profile_image"
                      name="profile_image"
                      onChange={handleFileChange}
                      className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  </div>
                </div>
              </div>

              <div className='flex justify-end items-center h-10 mt-5 gap-3'>
                <button onClick={handleChancel} className='text-[16px] text-white uppercase font-semibold text-left bg-red p-2 rounded-lg transform transition-transform duration-300 hover:scale-105'>Cancel</button>
                <button type='submit' className='text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105'>Submit</button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default CreateDoctor